import { writable } from 'svelte/store';

export const screen = writable('desktop');

const checkScreen = () => {
    if (window.innerWidth < 640) {
        screen.set('mobile');
    } else if (window.innerWidth >= 640 && window.innerWidth < 1024) {
        screen.set('tablet');
    } else {
        screen.set('desktop');
    }
};

if (typeof window !== 'undefined') {
    checkScreen();
    window.addEventListener('resize', checkScreen);
}
/*
mobile: width < 640px
tablet: 640px <= width < 1024px
desktop: width >= 1024px
*/